/**
 * Reports number/money formatters — extracted at people-attribution S7 so
 * small shared cells (PltvWithCac) can format the SAME way as the dashboard
 * without an import cycle. The dashboard re-exports them unchanged.
 */
export function formatInteger(value: number): string {
  return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(value);
}

export function formatNullableCurrency(value: number | null | undefined, currency = 'usd'): string {
  return value === null || value === undefined || Number.isNaN(value)
    ? 'n/a'
    : formatCurrency(value, currency);
}
export function formatCurrency(value: number, currency = 'usd'): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency.toUpperCase(),
    maximumFractionDigits: 2,
  }).format(value);
}
